import { Typography } from '@mui/material'
import React from 'react'
import { CampaignTable } from '../../common/campaign/CampaignTable'
import { Campaign } from '../../common/types/campaigns'
import { i18n } from '../index/index'
import { Widget } from './OldDashboardComponents'

interface Props {
  campaigns: Campaign[]
  stationId: string
}

export default function Campaigns({ campaigns, stationId }: Props) {
  return (
    <Widget>
      <Typography variant='h5'>{i18n.t('campaigns.heading')}</Typography>
      <CampaignTable campaigns={campaigns} />
    </Widget>
  )
}
